module.exports = __webpack_public_path__ + "static/media/rollingThunder.7d997762.png";